// Stored inside Meal, without own document
// tslint:disable-next-line:max-classes-per-file
export class Ingredient {
    public static SumCalories(ingredients: Ingredient[]): number {
        if (ingredients == null) {
            return 0;
        }
        const sum = ingredients.reduce((prev: number, next: Ingredient) => prev + next.calories, 0);
        return sum;
    }
    public displayName: string;
    public calories: number;
}

export type Allergens = 'Nuts' | 'Eggs' | 'Gluten' | 'Dairy';
